import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8f6180a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import { ref } from 'vue'
import { DataGroupMember } from '@/gp/GroupAdminModel'
import { useDataGroupMemberStore } from '@/gp/DataGroupMemberStore'
import Modal from '@/util/Modal.vue'
import FamilyGroupItem from '@/manage/familygroups/FamilyGroupItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DataGroupMemberRemoveModal',
  props: {
  profile: Boolean
},
  setup(__props, { expose: __expose }) {

const props = __props;



const dataGroupMemberRef = ref<DataGroupMember>()
const modalRef = ref<InstanceType<typeof Modal>>()

const dataGroupMemberStore = useDataGroupMemberStore()

__expose({
  open,
})

function open(dm: DataGroupMember) {
  dataGroupMemberRef.value = dm
  modalRef.value?.open()
}

async function removeMember() {
  await dataGroupMemberStore.deleteAsync(dataGroupMemberRef.value!)
  modalRef.value?.close()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    class: "member-remove-modal",
    "ok-style": "danger",
    onOk: removeMember
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Stop sharing ")
    ]),
    okText: _withCtx(() => [
      _createTextVNode(" Stop sharing ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (props.profile)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Are you sure you want to stop sharing the profile with this family group? "))
          : (_openBlock(), _createElementBlock("p", _hoisted_2, " Are you sure you want to stop sharing your tree with this family group? ")),
        _createVNode(FamilyGroupItem, {
          "family-group-id": dataGroupMemberRef.value?.principalId
        }, null, 8, ["family-group-id"])
      ])
    ]),
    _: 1
  }, 512))
}
}

})